module.exports = __webpack_public_path__ + "img/ER.ae08238c.svg";